import "./AbhaManagement.css";
import { useLocation } from "react-router-dom";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import AbhaManagementChild from "./AbhaManagementChild";

const AbhaManagement = () => {
    const { state } = useLocation();
    let abhaManagementRecord = state;
    return (
        <MainContentCard>
            <ErrorBoundaryRoutes page="AbhaManagementChild" route="/abha-management">
                <AbhaManagementChild abhaManagementRecord={abhaManagementRecord} />
            </ErrorBoundaryRoutes>
        </MainContentCard>
    )
}

export default AbhaManagement